import { render, staticRenderFns } from "./lectoParams.vue?vue&type=template&id=fd438b7c&scoped=true"
import script from "./lectoParams.vue?vue&type=script&lang=js"
export * from "./lectoParams.vue?vue&type=script&lang=js"
import style0 from "./lectoParams.vue?vue&type=style&index=0&id=fd438b7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd438b7c",
  null
  
)

export default component.exports